import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "img-banner py-4",
  "data-cy": "menu-item-banner"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "small normal"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "img-banner py-4",
  "data-cy": "menu-item-banner"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 0,
  class: "small normal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_card = _resolveComponent("ion-card")!

  return (_ctx.item)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.callback ? 'button' : 'router-link'), {
        key: 0,
        to: _ctx.path,
        "data-cy": "menu-item",
        class: "no-underline",
        id: 'item-' + _ctx.createSlug(_ctx.item.name),
        onClick: _ctx.itemClicked
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_card, {
            button: "",
            class: "my-0 mx-0 full-height"
          }, {
            default: _withCtx(() => [
              (!_ctx.isMobile)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.detail && _ctx.item.itemTextBanner)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.item.itemTextBanner), 1))
                      : _createCommentVNode("", true),
                    (_ctx.item.img)
                      ? (_openBlock(), _createBlock(_component_ion_img, {
                          key: 1,
                          src: require('@/assets/menu/' + _ctx.item.img),
                          alt: "",
                          class: _normalizeClass(_ctx.imageClass),
                          "data-cy": "menu-image"
                        }, null, 8, ["src", "class"]))
                      : (_ctx.item.cdnImg)
                        ? (_openBlock(), _createBlock(_component_ion_img, {
                            key: 2,
                            src: _ctx.item.cdnImg,
                            alt: "",
                            class: _normalizeClass(_ctx.imageClass),
                            "data-cy": "menu-image"
                          }, null, 8, ["src", "class"]))
                        : _createCommentVNode("", true),
                    _createVNode(_component_ion_item, {
                      detail: _ctx.isMobile,
                      class: "interstate-bold",
                      lines: "none",
                      "data-cy": "menu-info"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              innerHTML: _ctx.item.messageText ?? _ctx.item.name
                            }, null, 8, _hoisted_2),
                            (_ctx.route.path.includes('pizza-pals') && _ctx.groupNumber == 1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                  (_ctx.item.categoryName === 'Pizza')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.item.recipes[0].sizes[0].sizeName), 1))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_5, " "))
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["detail"])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.isMobile)
                ? (_openBlock(), _createBlock(_component_ion_row, {
                    key: 1,
                    class: "ion-align-items-center"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.detail && _ctx.item.itemTextBanner)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.item.itemTextBanner), 1))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_col, {
                        class: _normalizeClass(["px-0 py-0 img-col", { detailImg: _ctx.detail }]),
                        size: "5",
                        "data-cy": "menu-image"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.item.img)
                            ? (_openBlock(), _createBlock(_component_ion_img, {
                                key: 0,
                                src: require('@/assets/menu/' + _ctx.item.img),
                                alt: "",
                                class: _normalizeClass(_ctx.imageClass)
                              }, null, 8, ["src", "class"]))
                            : (_ctx.item.cdnImg)
                              ? (_openBlock(), _createBlock(_component_ion_img, {
                                  key: 1,
                                  src: _ctx.isMobile ? _ctx.item.mobileImg : _ctx.item.cdnImg,
                                  alt: "",
                                  class: _normalizeClass(_ctx.imageClass)
                                }, null, 8, ["src", "class"]))
                              : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["class"]),
                      _createVNode(_component_ion_col, {
                        class: _normalizeClass(["px-0 py-0 item-detail-col", { detailInfo: _ctx.detail }]),
                        size: "7",
                        "data-cy": "menu-info"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, {
                            detail: _ctx.isMobile,
                            class: "interstate-bold",
                            lines: "none"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", {
                                    innerHTML: _ctx.item.messageText ?? _ctx.item.name
                                  }, null, 8, _hoisted_7),
                                  (_ctx.route.path.includes('pizza-pals') && _ctx.groupNumber == 1 && _ctx.item.categoryName === 'Pizza')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.item.recipes[0].sizes[0].sizeName), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["detail"])
                        ]),
                        _: 1
                      }, 8, ["class"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["to", "id", "onClick"]))
    : _createCommentVNode("", true)
}